import React from 'react';

import { DataGrid } from '@material-ui/data-grid';

import './styles.css';

const Columns = [
  { field: 'request_number', headerName: 'Nº', width: 70 },
  { field: 'status', headerName: 'Status', width: 170 },
  { field: 'total_price', headerName: 'Preço', width: 170 },
  { field: 'request_type_name', headerName: 'Tipo', width: 170 },
  { field: 'created_at', headerName: 'Data Pedido', width: 170 },
];

function TableGrid({ rows, onSelect }) {
  const onSelectionChanged = ([requestId]) => {
    onSelect(requestId);
  };

  return (
    <div className="container" style={{ height: 400 }}>
      {rows && (
        <DataGrid
          rows={rows}
          columns={Columns}
          style={{ cursor: 'pointer' }}
          NoRowsOverlay
          pageSize={5}
          onSelectionModelChange={onSelectionChanged}
          getRowClassName={(params) =>
            params.row.statusId === 6 ? 'cancelledRequest' : ''
          }
        />
      )}
    </div>
  );
}

export default TableGrid;
